import template from './about.html';
import controller from './about.controller';
import './about.scss';

let aboutComponent = {
  bindings: {},
  template,
  controller
};

export default aboutComponent;



// WEBPACK FOOTER //
// ./client/app/components/about/about.component.js